import { base64ToBlob } from './APIRequestHelper';

export const printPdf = pdfFile => {
    const blob = new Blob([base64ToBlob(pdfFile)], { type: 'application/pdf' });
    const blobURL = window.URL.createObjectURL(blob);

    const noLocationWithScrollAndMenu = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,';
    const pdfWindowSize = 'resizable,screenX=50,screenY=50,width=850,height=1050';

    const pdfWindowParams = noLocationWithScrollAndMenu + pdfWindowSize;
    const pdfWindow = window.open(blobURL, '', pdfWindowParams);
    pdfWindow.print();
};
